
































































import {
  Vue,
  Prop,
  Component,
  Emit,
} from 'vue-property-decorator';

@Component
export default class DepositChoice extends Vue {
  @Prop({ type: String })
  value!: string;

  @Prop({ type: Boolean })
  disableQr!: boolean;

  @Prop({ type: Boolean })
  disableBank!: boolean;

  public choice = this.value;

  isSelected(value: string) {
    return this.choice === value;
  }

  @Emit('input')
  // eslint-disable-next-line class-methods-use-this
  onChoiceSelect(choice: string) {
    this.choice = choice;
    return choice;
  }
}
